import { ImageLoader } from "~/components/ImageLoader";
import { Icon, isValidIconType } from "~/components/Icon";
import { IconTypes } from "~/components/Icon/types";
import { cn } from "~/lib/utils";
import { RWA_COIN_ICON } from "~/consts";
import { ClassnamePassthruWrapper } from "~/components/ui/classname-passthru-wrapper";

// // // //

/**
 * Renders an icon for an individual search result
 * Supports icon rendering via Image URL or by using a predetermined FontAwesome icon
 */
export function SearchResultIcon(props: {
    src: undefined | string;
    className: undefined | string;
    wrapperClassName?: undefined | string;
    alt: string;
}) {
    const { src, alt, className, wrapperClassName } = props;

    if (!src) {
        return null;
    }

    if (isValidIconType(src)) {
        return (
            <ClassnamePassthruWrapper className={wrapperClassName}>
                <Icon
                    className={cn("w-4", className)}
                    icon={src as IconTypes}
                />
            </ClassnamePassthruWrapper>
        );
    }

    return (
        <ClassnamePassthruWrapper className={wrapperClassName}>
            <ImageLoader
                // NOTE - both dimensions are constrained here because some
                // partner-uploaded SVGs declare no intrinsic aspect ratio
                // (preserveAspectRatio="none"), which makes width-only sizing
                // fall back to the browser's default 150px height
                className="size-4 shrink-0 rounded-xs object-contain"
                fallbackClassName="bg-white opacity-50"
                src={src}
                alt={alt}
                fallbackSrc={RWA_COIN_ICON}
            />
        </ClassnamePassthruWrapper>
    );
}
